import * as React from "react"

import { cn } from "@/lib/shadcn-utils"

type FormInputErrorProps = {
  errors?: (string | undefined)[]
} & React.ComponentProps<"p">

export function FormInputError({
  errors,
  className,
  ...props
}: FormInputErrorProps) {
  if (!errors?.length) return null

  return (
    <p
      className={cn("tw-text-medium tw-text-red-600 tw-mt-1", className)}
      {...props}
    >
      {errors[0]}
    </p>
  )
}
